import { Component, OnInit, ViewChild } from "@angular/core";
import {
  MatTableDataSource,
  PageEvent,
  MatDialog,
  MatPaginator,
} from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import { User, Users } from "src/_models/users";
import { AppService } from "src/_services/app.service";
import { Location } from "@angular/common";
import { FormControl } from "@angular/forms";
import { AssignUserLimitComponent } from "../assign-user-limit/assign-user-limit.component";


@Component({
  selector: "app-operator-users",
  templateUrl: "./operator-users.component.html",
  styleUrls: ["./operator-users.component.scss"],
})
export class OperatorUsersComponent implements OnInit {
  usersDisplayedColumns: string[] = ["UserId", "UserName", "Balance", "Status", "Action"];

  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  users = new MatTableDataSource<User>();
  count: number = 0;
  searchUserName: string = "";
  operatorId;
  page = 1;
  pageSize = 15;
  orgPageSize = 15;
  length = 0;
  pageEvent: any = { pageIndex: 1, pageSize: 0, length: 0 };
  dropdownSettings: any = {};
  selectedStatus = new FormControl([]);
  statuses= ["ACTIVE","BLOCKED","BOT"]

  constructor(
    public dialog: MatDialog,
    private appService: AppService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
  ) {}

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: true,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: false,
    };
    this.operatorId = this.route.snapshot.params.OperatorId;
    this.getServerData();
  }

  onFilterChange() {
    this.page = 1;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
      }
    this.getServerData();
  }

  @ViewChild(MatPaginator) paginator: MatPaginator;
  getServerData(event?: PageEvent) {
    const pagination = {
      Number: 0,
      Page: 0,
    };
    let filters = {
      operatorId: this.operatorId,
      page :this.page,
      pageSize: this.orgPageSize,
      status: this.selectedStatus.value.length != 0 ? this.selectedStatus.value[0] :"",
      partialUserName: this.searchUserName
    }
    this.appService
      .getOperatorUsers(filters)
      .subscribe((res) => {
        if (res.status === "RS_OK") {
            this.users = new MatTableDataSource<any>(res.users);
            if (this.page == 1) {
              this.length = res.totalRecords
            }
        } else {
          this.appService.openErrorBar(res.errorDescription);
          this.router.navigateByUrl("/login");
        }
      });
  }

  goBack = () => {
    this.location.back();
  };

  handleChange(e, user: User) {
    if (e.checked) {
      this.appService.unBlockUser(user.userId, this.operatorId).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.appService.openSuccessBar(res.errorDescription);
        } else {
          this.appService.openErrorBar(res.errorDescription);
        }
      });
    } else {
      this.appService.blockUser(user.userId, this.operatorId).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.appService.openSuccessBar(res.errorDescription);
        } else {
          this.appService.openErrorBar(res.errorDescription);
        }
      });
    }
  }

  assignLimit(user: User) {
    const dialogRef = this.dialog.open(AssignUserLimitComponent, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      width: "460px",
      panelClass: "assign-limit-dialog-panel",
      data: {
        userId: user.userId,
        userName: user.userName,
        operatorId: this.operatorId,
        limitId: user.limitId,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getServerData();
      }
    });
  }

  changePagination(event: PageEvent) {
    this.pageEvent = event;
    this.page = event.pageIndex + 1;
    this.pageSize = this.length;
    this.orgPageSize = event.pageSize;
    this.getServerData();
  }

  searchUser(event) {
    const value = event.target.value;
    this.searchUserName = value;
    this.getServerData();
    // this.users.filter = value.trim().toLocaleLowerCase();
  }
}
